// Web shim for react-native-localize using browser APIs

export function getLocales() {
  const languages = navigator.languages || [navigator.language || 'en'];
  return languages.map((tag) => {
    const parts = tag.split('-');
    return {
      languageCode: parts[0],
      countryCode: parts[1] || '',
      languageTag: tag,
      isRTL: ['ar', 'he', 'fa', 'ur'].includes(parts[0]),
    };
  });
}

export function getNumberFormatSettings() {
  return {
    decimalSeparator: '.',
    groupingSeparator: ',',
  };
}

export function getCalendar() {
  return 'gregorian';
}

export function getCountry() {
  const locales = getLocales();
  return locales[0]?.countryCode || 'US';
}

export function getCurrencies() {
  return ['USD'];
}

export function getTemperatureUnit() {
  return 'celsius';
}

export function getTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function uses24HourClock() {
  return false;
}

export function addEventListener() {
  return { remove: () => {} };
}
